import React from 'react';
import PropTypes from 'prop-types';

import { SESSION_STATUS_DROPDOWN_OPTIONS } from '../../constants';
import * as S from './styles';

function Filters({ onStatusSelected, onWorkspaceSearch, onProjectSearch }) {
  const handleWorkspaceSearch = (e, { value }) => {
    onWorkspaceSearch(value);
  };

  const handleProjectSearch = (e, { value }) => {
    onProjectSearch(value);
  };

  return (
    <S.Container>
      <S.Dropdown
        onChange={(e, { value }) => onStatusSelected(value)}
        placeholder="Status"
        fluid
        multiple
        selection
        options={SESSION_STATUS_DROPDOWN_OPTIONS}
      />
      <S.Input
        onChange={handleWorkspaceSearch}
        placeholder="Workspace"
      />
      <S.Input
        onChange={handleProjectSearch}
        placeholder="Project"
      />
    </S.Container>
  );
}

Filters.propTypes = {
  onStatusSelected: PropTypes.func.isRequired,
  onWorkspaceSearch: PropTypes.func.isRequired,
  onProjectSearch: PropTypes.func.isRequired,
};

export default Filters;
